import { post, del, get } from './generic.api';

export const fetchEditorials = async (sourceId) => {
    try {
      const response = await get('/editorial/', {
            source: sourceId 
      });
      return response.results; // Corrige para retornar a propriedade results
    } catch (error) {
      console.error('Erro ao carregar editoriais:', error.response);
      throw error;
    }
  };